import ActionsAPI from "./ActionsAPI"
import AgendaAPI from "./AgendaAPI"
import ConfigurationAPI from "./ConfigurationAPI"
import MensaAPI from "./MensaAPI"
import NewsAPI from "./NewsAPI"
import PresenceAPI from "./PresenceAPI"
import TimetableAPI from "./TimetableAPI"
import WochenbriefAPI from "./WochenbriefAPI"

class API {
  static Configuration = new ConfigurationAPI()
  static News = new NewsAPI()
  static Mensa = new MensaAPI()
  static Agenda = new AgendaAPI()
  static Timetable = new TimetableAPI()
  static Actions = new ActionsAPI()
  static Presence = new PresenceAPI()
  static Wochenbrief = new WochenbriefAPI()
}

export default API
